<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor">
  <path d="M4 16L2.6 14.575L5.175 12H-2V10H5.175L2.6 7.425L4 6L9 11L4 16ZM12 10L7 5L12 0L13.4 1.425L10.825 4H18V6H10.825L13.4 8.575L12 10Z" />
</svg>
